import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "La Materia",
    text: "Malti pregiati, luppoli freschi e la nostra acqua. Ogni ingrediente racconta la terra da cui proviene. Nessun estratto, nessuna scorciatoia.",
    img: "/api/media/manifesto-la-materia.jpeg",
    alt: "La Materia — malti pregiati e luppoli freschi del Birrificio Vecchio Cinghiale",
  },
  {
    num: "02",
    title: "Il Tempo",
    text: "La fretta è nemica del gusto. Ogni birra fermenta esattamente il tempo necessario per esprimere il miglior risultato da ciascun ingrediente: né un giorno di più, né uno di meno.",
    img: "/api/media/manifesto-il-tempo.jpeg",
    alt: "Il Tempo — fermentazione lenta della birra al Birrificio Vecchio Cinghiale",
  },
  {
    num: "03",
    title: "La Lattina",
    text: "Scegliamo la lattina non per moda, ma per rispetto della birra: protegge il contenuto dalla luce, garantisce una sigillatura perfetta contro l'ossigeno e, se conservata correttamente, è il modo migliore per custodire il sapore esattamente come il birraio lo ha pensato.",
    img: "/api/media/manifesto-la-lattina.jpeg",
    alt: "La Lattina — birra in lattina slim 33cl del Birrificio Vecchio Cinghiale",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export const Manifesto = () => {
  return (
    <section id="manifesto" className="py-24 md:py-40 bg-[#0D110D]" data-testid="manifesto-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <motion.div
          variants={reveal}
          initial={false}
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="mb-24 max-w-3xl"
        >
          <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-6">
            Il Nostro Manifesto
          </p>
          <h2 className="font-serif-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95] text-[#E8E2D2]">
            Crediamo che una birra sia <span className="italic text-[#D47738]">tradizione</span>, non industria.
          </h2>
        </motion.div>

        <div className="space-y-28">
          {CHAPTERS.map((c, i) => (
            <div
              key={c.num}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center ${
                i % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <motion.div
                variants={reveal}
                initial={false}
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                className="lg:col-span-6 [direction:ltr]"
              >
                <div className="overflow-hidden">
                  <motion.img
                    initial={{ scale: 1.2 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                    src={c.img}
                    alt={c.alt}
                    className="w-full h-[420px] md:h-[560px] object-cover grayscale-[30%]"
                  />
                </div>
              </motion.div>

              <motion.div
                variants={reveal}
                initial={false}
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                className="lg:col-span-6 [direction:ltr]"
              >
                <span className="font-mono-accent text-6xl md:text-8xl text-[#D47738]/40 block mb-6">
                  {c.num}
                </span>
                <h3 className="font-serif-display text-4xl md:text-5xl text-[#E8E2D2] mb-6">
                  {c.title}
                </h3>
                <p className="text-base md:text-lg text-[#E8E2D2]/60 leading-relaxed max-w-lg">
                  {c.text}
                </p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
